module.exports = __webpack_public_path__ + "static/media/welcome_image_desktop.71a9091a.jpg";